import { useEffect, useRef } from 'react';
import { getAmplitudeClient } from '../utils/amplitude-client';
import { syncAmplitudeIdentity, } from '../utils/amplitude-identity';
// Call it where the logged-out state is visible too, so the logout resets Amplitude.
export const useAmplitudeIdentity = ({ environment, apiKey }, user) => {
    const identifiedUserIdRef = useRef(null);
    const userRef = useRef(user);
    userRef.current = user;
    // Callers build the user object every render; re-identify only when it changes.
    const userKey = user ? JSON.stringify(user) : null;
    useEffect(() => {
        const amplitude = getAmplitudeClient({ environment, apiKey });
        if (!amplitude)
            return;
        identifiedUserIdRef.current = syncAmplitudeIdentity(amplitude, identifiedUserIdRef.current, userRef.current);
    }, [environment, apiKey, userKey]);
};
//# sourceMappingURL=use-amplitude-identity.js.map